import React, { useState } from 'react'
import { firestore } from '../../../firebase';

function AddQuestion({quizId}) {

    const [question, setQuestion] = useState("");
    const [number, setNumber] = useState(0);
    const [error, setError] = useState("");

    async function addQuestionHandler(e) {
        e.preventDefault();
        try {
            const questionRef = firestore.collection("quiz").doc(quizId).collection("questions");

            const data = {
                number: +number,
                question
            }
            questionRef.add(data);

        } catch (error) {
            setError("Kunne ikke legge til spørsmål");
        }
    }

    return (
        <form onSubmit={addQuestionHandler}>

            <label>Spørsmål</label>
            <input className="form-control mb-2" value={question} onChange={e => setQuestion(e.target.value)} />

            <label>Spørsmål nummer</label>
            <input type="number" value={number} className="form-control mb-2" onChange={e => setNumber(e.target.value)} />

            {error && <div className="alert alert-danger">{error}</div>}
            <button className="btn btn-block btn-success">Legg til</button>
        </form>
    )

}
export default AddQuestion